/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultEnvironment = "development";
	var nodeEnv = ("production");
	
	var configuration = {
	  test: {
	    tpmHost: "https://test-tpm-server.sp.org"
	  },
	  development: {
	    tpmHost: "http://tpm-integration.vigetx.com",
	    cdnHost: ""
	  },
	  integration: {
	    tpmHost: "http://tpm-integration.vigetx.com",
	    cdnHost: "http://nthp-thisplacematters-widget.s3.amazonaws.com/integration"
	  },
	  feature: {
	    tpmHost: "http://tpm-integration.vigetx.com",
	    cdnHost: "http://nthp-thisplacematters-widget.s3.amazonaws.com/feature"
	  },
	  staging: {
	    tpmHost: "https://tpm-staging.savingplaces.org",
	    cdnHost: "https://nthp-thisplacematters-widget.s3.amazonaws.com/staging"
	  },
	  production: {
	    tpmHost: "https://tpm.savingplaces.org",
	    cdnHost: "https://nthp-thisplacematters-widget.s3.amazonaws.com/production"
	  }
	};
	
	var environment = nodeEnv ? nodeEnv : defaultEnvironment;
	exports.environment = environment;
	var environmentConfiguration = configuration[environment];
	exports.environmentConfiguration = environmentConfiguration;
	exports["default"] = environmentConfiguration;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _appTemplatesWidgetMustache = __webpack_require__(13);
	
	var _appTemplatesWidgetMustache2 = _interopRequireDefault(_appTemplatesWidgetMustache);
	
	var _libRenderer = __webpack_require__(6);
	
	var _libRenderer2 = _interopRequireDefault(_libRenderer);
	
	var _appModelsWidget = __webpack_require__(4);
	
	var _appModelsWidget2 = _interopRequireDefault(_appModelsWidget);
	
	var WidgetComponent = (function () {
	  function WidgetComponent(props) {
	    var _this = this;
	
	    _classCallCheck(this, WidgetComponent);
	
	    this.renderer = props.renderer || _libRenderer2['default'];
	    this.element = props.element;
	    this.triggerElements = props.triggerElements || [];
	
	    this.inDOM = false;
	    this.widget = new _appModelsWidget2['default'](props, function () {
	      _this.render();
	    });
	  }
	
	  _createClass(WidgetComponent, [{
	    key: 'render',
	    value: function render(callback) {
	      this.renderer.render(_appTemplatesWidgetMustache2['default'].render(this.widget.templateContext()), this.element);
	
	      this.bindEventHandlers();
	      if (!this.inDOM) {
	        this.inDOM = true;
	        this.widget.init();
	      }
	
	      if (typeof callback === 'function') callback(this);
	    }
	  }, {
	    key: 'bindEventHandlers',
	    value: function bindEventHandlers() {
	      // Widget Trigger Click Handlers
	      for (var i = 0; i < this.triggerElements.length; ++i) {
	        if (this.triggerElements[i].getAttribute('data-widgetid') === this.widget.widgetId()) this.triggerElements[i].onclick = this.triggerHandler.bind(this);
	      }
	
	      // Widget UI Click Handlers
	      this.bindHandlerToClick(".tpm-button", this.widget.toggleVote);
	      this.bindHandlerToClick(".tpm-upload-cta", this.widget.toggleModal);
	      this.bindHandlerToClick(".tpm-modal-background", this.widget.toggleModal);
	    }
	  }, {
	    key: 'triggerHandler',
	    value: function triggerHandler(event) {
	      event.preventDefault();
	      this.widget.toggleModal();
	    }
	  }, {
	    key: 'bindHandlerToClick',
	    value: function bindHandlerToClick(selector, handler) {
	      var boundElement = this.element.querySelector(selector);
	      if (boundElement) boundElement.onclick = (function (event) {
	        event.preventDefault();
	        handler.call(this.widget, event);
	      }).bind(this);
	    }
	  }]);
	
	  return WidgetComponent;
	})();
	
	exports['default'] = WidgetComponent;
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configEnvironment = __webpack_require__(1);
	
	var _appComponentsWidget_component = __webpack_require__(2);
	
	var _appComponentsWidget_component2 = _interopRequireDefault(_appComponentsWidget_component);
	
	var _libSafely_execute = __webpack_require__(7);
	
	var _libSafely_execute2 = _interopRequireDefault(_libSafely_execute);
	
	(0, _libSafely_execute2['default'])(function () {
	  var cdnHost = _configEnvironment.environmentConfiguration.cdnHost;
	  var widgetClassName = "tpm-widget";
	  var widgetTriggerClassName = "tpm-widget-trigger";
	
	  var listenForDOMReady = function listenForDOMReady() {
	    window.TPMListening = true;
	
	    document.onreadystatechange = function () {
	      if (document.readyState !== "loading") {
	        preInitialize();
	      }
	    };
	  };
	
	  var preInitialize = function preInitialize() {
	    var ua = navigator.userAgent;
	    var re = /MSIE \d\.\d/; // IE9 and under
	    var lteIE9 = re.test(ua);
	
	    if (lteIE9) {
	      var widgetScript = document.getElementsByClassName(widgetClassName)[0].previousElementSibling;
	      var polyfillScript = document.createElement('script');
	      widgetScript.parentNode.insertBefore(polyfillScript, widgetScript);
	      polyfillScript.onload = function () {
	        initializeTPM();
	      };
	      polyfillScript.src = cdnHost + '/static/xhr-or-xdr.js';
	    } else {
	      initializeTPM();
	    }
	  };
	
	  var initializeTPM = function initializeTPM(event) {
	    if (window.TPMInitialized) return;
	    window.TPMInitialized = true;
	
	    var elements = document.getElementsByClassName(widgetClassName);
	    var triggerElements = document.getElementsByClassName(widgetTriggerClassName);
	
	    for (var i = 0; i < elements.length; i++) {
	      var element = elements[i];
	      var widgetId = element.getAttribute('data-widgetid');
	      var component = new _appComponentsWidget_component2['default']({ element: element, widgetId: widgetId, triggerElements: triggerElements });
	      component.render();
	    }
	  };
	
	  window.TPMListening || listenForDOMReady();
	});

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _configEnvironment = __webpack_require__(1);
	
	var _libStorage = __webpack_require__(8);
	
	var _libUnique_id = __webpack_require__(9);
	
	var _libAjax = __webpack_require__(5);
	
	var Widget = (function () {
	  function Widget(props, onStateChange) {
	    _classCallCheck(this, Widget);
	
	    this._persistedProperites = ["upvoted", "downvoted"];
	
	    this.state = this._getDefaultState(props);
	    this.onStateChange = onStateChange;
	  }
	
	  _createClass(Widget, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      (0, _libAjax.getPlaceInfo)(this.widgetId(), function (widgetData) {
	        _this._setState({
	          name: widgetData.name,
	          upvotes: widgetData.upvote_count
	        });
	
	        _this.state.upvoted && _this.animateHeart('end');
	      });
	    }
	  }, {
	    key: 'templateContext',
	    value: function templateContext() {
	      return _extends({}, this._getState(), this._computedProperties(this._getState()));
	    }
	  }, {
	    key: 'animateHeart',
	    value: function animateHeart(position) {
	      this.state.element.setAttribute('data-animate', position);
	    }
	  }, {
	    key: 'toggleVote',
	    value: function toggleVote() {
	      this._upvoted() ? this._downvote() : this._upvote();
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal() {
	      this._setState({
	        modalOpen: !this._modalOpen(),
	        scrollPos: !this._modalOpen() ? document.documentElement.scrollTop || document.body.scrollTop : this._getState().scrollPos
	      });
	
	      // set scroll position
	      this._scrollTo(!this._modalOpen() ? this._getState().scrollPos : 0);
	    }
	  }, {
	    key: 'widgetId',
	    value: function widgetId() {
	      return this._getState().widgetId;
	    }
	
	    // Private
	
	  }, {
	    key: '_scrollTo',
	    value: function _scrollTo(pos) {
	      document.documentElement.scrollTop = document.body.scrollTop = pos;
	    }
	  }, {
	    key: '_getDefaultState',
	    value: function _getDefaultState(props) {
	      return {
	        element: props.element,
	        id: (0, _libUnique_id.uniqueId)(),
	        widgetId: props.widgetId,
	        upvotes: 0,
	        upvoted: (0, _libStorage.readFromStorage)(props.widgetId, "upvoted") === "true",
	        downvoted: (0, _libStorage.readFromStorage)(props.widgetId, "downvoted") === "true",
	        modalOpen: false,
	        scrollPos: 0,
	        name: null,
	        tpmHost: _configEnvironment.environmentConfiguration.tpmHost
	      };
	    }
	  }, {
	    key: '_setState',
	    value: function _setState(stateUpdates) {
	      this.state = _extends({}, this.state, stateUpdates);
	      var state = this._getState();
	
	      for (var propertyIndex in this._persistedProperites) {
	        var property = this._persistedProperites[propertyIndex];
	        (0, _libStorage.writeToStorage)(this.widgetId(), property, this['_' + property]());
	      }
	
	      if (this.onStateChange) this.onStateChange(state);
	      return state;
	    }
	  }, {
	    key: '_getState',
	    value: function _getState() {
	      return _extends({}, this.state);
	    }
	  }, {
	    key: '_computedProperties',
	    value: function _computedProperties(state) {
	      return {
	        upvotedByAnybody: state.upvotes > 0,
	        upvoteStatNumber: state.upvotes,
	        upvoteStatWord: state.upvotes === 1 ? "person" : "people",
	        upvoteStatClass: state.upvoted ? "-upvoted" : ""
	      };
	    }
	  }, {
	    key: '_upvote',
	    value: function _upvote() {
	      this.animateHeart('begin');
	      this._setState({ upvoted: true, upvotes: this._upvoteCount() + 1 });
	
	      if (!this._downvoted()) (0, _libAjax.postUpvote)(this.widgetId());
	    }
	  }, {
	    key: '_downvote',
	    value: function _downvote() {
	      this._setState({ upvoted: false, downvoted: true, upvotes: this._upvoteCount() - 1 });
	    }
	  }, {
	    key: '_upvoteCount',
	    value: function _upvoteCount() {
	      return this._getState().upvotes;
	    }
	  }, {
	    key: '_upvoted',
	    value: function _upvoted() {
	      return this._getState().upvoted;
	    }
	  }, {
	    key: '_downvoted',
	    value: function _downvoted() {
	      return this._getState().downvoted;
	    }
	  }, {
	    key: '_modalOpen',
	    value: function _modalOpen() {
	      return this._getState().modalOpen;
	    }
	  }]);
	
	  return Widget;
	})();
	
	exports['default'] = Widget;
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.postUpvote = postUpvote;
	exports.getPlaceInfo = getPlaceInfo;
	
	var _configEnvironment = __webpack_require__(1);
	
	var tpmHost = _configEnvironment.environmentConfiguration.tpmHost;
	
	function postUpvote(widgetId) {
	  var request = new XMLHttpRequest();
	  // If you care about what happens with this request:
	
	  // request.onreadystatechange=function() {
	  //   if (request.readyState == 4 && request.status == 201) {
	  //     var serverResponse = request.responseText;
	  //     console.log(serverResponse);
	  //   }
	  // }
	
	  // But yeah, we don't care what happens with this request right now.
	
	  request.open("POST", tpmHost + "/widgets/" + widgetId + "/upvote", true);
	  request.send();
	}
	
	function getPlaceInfo(widgetId, callback) {
	  var request = new XMLHttpRequest();
	  request.onreadystatechange = function () {
	    if (request.readyState == 4 && request.status == 200) {
	      var responseJson = JSON.parse(request.responseText);
	      callback(responseJson);
	    }
	  };
	
	  request.open("GET", tpmHost + "/widgets/" + widgetId + ".json", true);
	  request.send();
	}

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  render: function render(content, domElement) {
	    domElement.innerHTML = content;
	  }
	};
	module.exports = exports["default"];

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports["default"] = function (unsafeFunction) {
	  try {
	    unsafeFunction();
	  } catch (e) {
	    console.error("Error caught by safelyExecute:", e);
	  }
	};
	
	module.exports = exports["default"];

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.writeToStorage = writeToStorage;
	exports.readFromStorage = readFromStorage;
	var localStorageKey = 'thisplacematters.places';
	
	function writeToStorage(widgetId, key, value) {
	  return localStorage.setItem([localStorageKey, widgetId, key].join('.'), value);
	}
	
	function readFromStorage(widgetId, key) {
	  return localStorage.getItem([localStorageKey, widgetId, key].join('.'));
	}

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uniqueId = uniqueId;
	var uidCounter = 0;
	var prefix = "tpm-uid";
	
	function uniqueId() {
	  var uid = [prefix, uidCounter].join("-");
	  uidCounter += 1;
	  return uid;
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	(function (Hogan) {
	  // Setup regex  assignments
	  // remove whitespace according to Mustache spec
	  var rIsWhitespace = /\S/,
	      rQuot = /\"/g,
	      rNewline =  /\n/g,
	      rCr = /\r/g,
	      rSlash = /\\/g,
	      rLineSep = /\u2028/,
	      rParagraphSep = /\u2029/;
	
	  Hogan.tags = {
	    '#': 1, '^': 2, '<': 3, '$': 4,
	    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
	    '{': 10, '&': 11, '_t': 12
	  };
	
	  Hogan.scan = function scan(text, delimiters) {
	    var len = text.length,
	        IN_TEXT = 0,
	        IN_TAG_TYPE = 1,
	        IN_TAG = 2,
	        state = IN_TEXT,
	        tagType = null,
	        tag = null,
	        buf = '',
	        tokens = [],
	        seenTag = false,
	        i = 0,
	        lineStart = 0,
	        otag = '{{',
	        ctag = '}}';
	
	    function addBuf() {
	      if (buf.length > 0) {
	        tokens.push({tag: '_t', text: new String(buf)});
	        buf = '';
	      }
	    }
	
	    function lineIsWhitespace() {
	      var isAllWhitespace = true;
	      for (var j = lineStart; j < tokens.length; j++) {
	        isAllWhitespace =
	          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
	          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
	        if (!isAllWhitespace) {
	          return false;
	        }
	      }
	
	      return isAllWhitespace;
	    }
	
	    function filterLine(haveSeenTag, noNewLine) {
	      addBuf();
	
	      if (haveSeenTag && lineIsWhitespace()) {
	        for (var j = lineStart, next; j < tokens.length; j++) {
	          if (tokens[j].text) {
	            if ((next = tokens[j+1]) && next.tag == '>') {
	              // set indent to token value
	              next.indent = tokens[j].text.toString()
	            }
	            tokens.splice(j, 1);
	          }
	        }
	      } else if (!noNewLine) {
	        tokens.push({tag:'\n'});
	      }
	
	      seenTag = false;
	      lineStart = tokens.length;
	    }
	
	    function changeDelimiters(text, index) {
	      var close = '=' + ctag,
	          closeIndex = text.indexOf(close, index),
	          delimiters = trim(
	            text.substring(text.indexOf('=', index) + 1, closeIndex)
	          ).split(' ');
	
	      otag = delimiters[0];
	      ctag = delimiters[delimiters.length - 1];
	
	      return closeIndex + close.length - 1;
	    }
	
	    if (delimiters) {
	      delimiters = delimiters.split(' ');
	      otag = delimiters[0];
	      ctag = delimiters[1];
	    }
	
	    for (i = 0; i < len; i++) {
	      if (state == IN_TEXT) {
	        if (tagChange(otag, text, i)) {
	          --i;
	          addBuf();
	          state = IN_TAG_TYPE;
	        } else {
	          if (text.charAt(i) == '\n') {
	            filterLine(seenTag);
	          } else {
	            buf += text.charAt(i);
	          }
	        }
	      } else if (state == IN_TAG_TYPE) {
	        i += otag.length - 1;
	        tag = Hogan.tags[text.charAt(i + 1)];
	        tagType = tag ? text.charAt(i + 1) : '_v';
	        if (tagType == '=') {
	          i = changeDelimiters(text, i);
	          state = IN_TEXT;
	        } else {
	          if (tag) {
	            i++;
	          }
	          state = IN_TAG;
	        }
	        seenTag = i;
	      } else {
	        if (tagChange(ctag, text, i)) {
	          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
	                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
	          buf = '';
	          i += ctag.length - 1;
	          state = IN_TEXT;
	          if (tagType == '{') {
	            if (ctag == '}}') {
	              i++;
	            } else {
	              cleanTripleStache(tokens[tokens.length - 1]);
	            }
	          }
	        } else {
	          buf += text.charAt(i);
	        }
	      }
	    }
	
	    filterLine(seenTag, true);
	
	    return tokens;
	  }
	
	  function cleanTripleStache(token) {
	    if (token.n.substr(token.n.length - 1) === '}') {
	      token.n = token.n.substring(0, token.n.length - 1);
	    }
	  }
	
	  function trim(s) {
	    if (s.trim) {
	      return s.trim();
	    }
	
	    return s.replace(/^\s*|\s*$/g, '');
	  }
	
	  function tagChange(tag, text, index) {
	    if (text.charAt(index) != tag.charAt(0)) {
	      return false;
	    }
	
	    for (var i = 1, l = tag.length; i < l; i++) {
	      if (text.charAt(index + i) != tag.charAt(i)) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  // the tags allowed inside super templates
	  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};
	
	  function buildTree(tokens, kind, stack, customTags) {
	    var instructions = [],
	        opener = null,
	        tail = null,
	        token = null;
	
	    tail = stack[stack.length - 1];
	
	    while (tokens.length > 0) {
	      token = tokens.shift();
	
	      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
	        throw new Error('Illegal content in < super tag.');
	      }
	
	      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
	        stack.push(token);
	        token.nodes = buildTree(tokens, token.tag, stack, customTags);
	      } else if (token.tag == '/') {
	        if (stack.length === 0) {
	          throw new Error('Closing tag without opener: /' + token.n);
	        }
	        opener = stack.pop();
	        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
	          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
	        }
	        opener.end = token.i;
	        return instructions;
	      } else if (token.tag == '\n') {
	        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
	      }
	
	      instructions.push(token);
	    }
	
	    if (stack.length > 0) {
	      throw new Error('missing closing tag: ' + stack.pop().n);
	    }
	
	    return instructions;
	  }
	
	  function isOpener(token, tags) {
	    for (var i = 0, l = tags.length; i < l; i++) {
	      if (tags[i].o == token.n) {
	        token.tag = '#';
	        return true;
	      }
	    }
	  }
	
	  function isCloser(close, open, tags) {
	    for (var i = 0, l = tags.length; i < l; i++) {
	      if (tags[i].c == close && tags[i].o == open) {
	        return true;
	      }
	    }
	  }
	
	  function stringifySubstitutions(obj) {
	    var items = [];
	    for (var key in obj) {
	      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
	    }
	    return "{ " + items.join(",") + " }";
	  }
	
	  function stringifyPartials(codeObj) {
	    var partials = [];
	    for (var key in codeObj.partials) {
	      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
	    }
	    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
	  }
	
	  Hogan.stringify = function(codeObj, text, options) {
	    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
	  }
	
	  var serialNo = 0;
	  Hogan.generate = function(tree, text, options) {
	    serialNo = 0;
	    var context = { code: '', subs: {}, partials: {} };
	    Hogan.walk(tree, context);
	
	    if (options.asString) {
	      return this.stringify(context, text, options);
	    }
	
	    return this.makeTemplate(context, text, options);
	  }
	
	  Hogan.wrapMain = function(code) {
	    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
	  }
	
	  Hogan.template = Hogan.Template;
	
	  Hogan.makeTemplate = function(codeObj, text, options) {
	    var template = this.makePartials(codeObj);
	    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
	    return new this.template(template, text, this, options);
	  }
	
	  Hogan.makePartials = function(codeObj) {
	    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
	    for (key in template.partials) {
	      template.partials[key] = this.makePartials(template.partials[key]);
	    }
	    for (key in codeObj.subs) {
	      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
	    }
	    return template;
	  }
	
	  function esc(s) {
	    return s.replace(rSlash, '\\\\')
	            .replace(rQuot, '\\\"')
	            .replace(rNewline, '\\n')
	            .replace(rCr, '\\r')
	            .replace(rLineSep, '\\u2028')
	            .replace(rParagraphSep, '\\u2029');
	  }
	
	  function chooseMethod(s) {
	    return (~s.indexOf('.')) ? 'd' : 'f';
	  }
	
	  function createPartial(node, context) {
	    var prefix = "<" + (context.prefix || "");
	    var sym = prefix + node.n + serialNo++;
	    context.partials[sym] = {name: node.n, partials: {}};
	    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
	    return sym;
	  }
	
	  Hogan.codegen = {
	    '#': function(node, context) {
	      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
	                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
	                      't.rs(c,p,' + 'function(c,p,t){';
	      Hogan.walk(node.nodes, context);
	      context.code += '});c.pop();}';
	    },
	
	    '^': function(node, context) {
	      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
	      Hogan.walk(node.nodes, context);
	      context.code += '};';
	    },
	
	    '>': createPartial,
	    '<': function(node, context) {
	      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
	      Hogan.walk(node.nodes, ctx);
	      var template = context.partials[createPartial(node, context)];
	      template.subs = ctx.subs;
	      template.partials = ctx.partials;
	    },
	
	    '$': function(node, context) {
	      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
	      Hogan.walk(node.nodes, ctx);
	      context.subs[node.n] = ctx.code;
	      if (!context.inPartial) {
	        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
	      }
	    },
	
	    '\n': function(node, context) {
	      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
	    },
	
	    '_v': function(node, context) {
	      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
	    },
	
	    '_t': function(node, context) {
	      context.code += write('"' + esc(node.text) + '"');
	    },
	
	    '{': tripleStache,
	
	    '&': tripleStache
	  }
	
	  function tripleStache(node, context) {
	    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
	  }
	
	  function write(s) {
	    return 't.b(' + s + ');';
	  }
	
	  Hogan.walk = function(nodelist, context) {
	    var func;
	    for (var i = 0, l = nodelist.length; i < l; i++) {
	      func = Hogan.codegen[nodelist[i].tag];
	      func && func(nodelist[i], context);
	    }
	    return context;
	  }
	
	  Hogan.parse = function(tokens, text, options) {
	    options = options || {};
	    return buildTree(tokens, '', [], options.sectionTags || []);
	  }
	
	  Hogan.cache = {};
	
	  Hogan.cacheKey = function(text, options) {
	    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
	  }
	
	  Hogan.compile = function(text, options) {
	    options = options || {};
	    var key = Hogan.cacheKey(text, options);
	    var template = this.cache[key];
	
	    if (template) {
	      var partials = template.partials;
	      for (var name in partials) {
	        delete partials[name].instance;
	      }
	      return template;
	    }
	
	    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
	    return this.cache[key] = template;
	  }
	})( true ? exports : Hogan);


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	// This file is for use with Node.js. See dist/ for browser files.
	
	var Hogan = __webpack_require__(10);
	Hogan.Template = __webpack_require__(12).Template;
	Hogan.template = Hogan.Template;
	module.exports = Hogan;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	var Hogan = {};
	
	(function (Hogan) {
	  Hogan.Template = function (codeObj, text, compiler, options) {
	    codeObj = codeObj || {};
	    this.r = codeObj.code || this.r;
	    this.c = compiler;
	    this.options = options || {};
	    this.text = text || '';
	    this.partials = codeObj.partials || {};
	    this.subs = codeObj.subs || {};
	    this.buf = '';
	  }
	
	  Hogan.Template.prototype = {
	    // render: replaced by generated code.
	    r: function (context, partials, indent) { return ''; },
	
	    // variable escaping
	    v: hoganEscape,
	
	    // triple stache
	    t: coerceToString,
	
	    render: function render(context, partials, indent) {
	      return this.ri([context], partials || {}, indent);
	    },
	
	    // render internal -- a hook for overrides that catches partials too
	    ri: function (context, partials, indent) {
	      return this.r(context, partials, indent);
	    },
	
	    // ensurePartial
	    ep: function(symbol, partials) {
	      var partial = this.partials[symbol];
	
	      // check to see that if we've instantiated this partial before
	      var template = partials[partial.name];
	      if (partial.instance && partial.base == template) {
	        return partial.instance;
	      }
	
	      if (typeof template == 'string') {
	        if (!this.c) {
	          throw new Error("No compiler available.");
	        }
	        template = this.c.compile(template, this.options);
	      }
	
	      if (!template) {
	        return null;
	      }
	
	      // We use this to check whether the partials dictionary has changed
	      this.partials[symbol].base = template;
	
	      if (partial.subs) {
	        // Make sure we consider parent template now
	        if (!partials.stackText) partials.stackText = {};
	        for (key in partial.subs) {
	          if (!partials.stackText[key]) {
	            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
	          }
	        }
	        template = createSpecializedPartial(template, partial.subs, partial.partials,
	          this.stackSubs, this.stackPartials, partials.stackText);
	      }
	      this.partials[symbol].instance = template;
	
	      return template;
	    },
	
	    // tries to find a partial in the current scope and render it
	    rp: function(symbol, context, partials, indent) {
	      var partial = this.ep(symbol, partials);
	      if (!partial) {
	        return '';
	      }
	
	      return partial.ri(context, partials, indent);
	    },
	
	    // render a section
	    rs: function(context, partials, section) {
	      var tail = context[context.length - 1];
	
	      if (!isArray(tail)) {
	        section(context, partials, this);
	        return;
	      }
	
	      for (var i = 0; i < tail.length; i++) {
	        context.push(tail[i]);
	        section(context, partials, this);
	        context.pop();
	      }
	    },
	
	    // maybe start a section
	    s: function(val, ctx, partials, inverted, start, end, tags) {
	      var pass;
	
	      if (isArray(val) && val.length === 0) {
	        return false;
	      }
	
	      if (typeof val == 'function') {
	        val = this.ms(val, ctx, partials, inverted, start, end, tags);
	      }
	
	      pass = !!val;
	
	      if (!inverted && pass && ctx) {
	        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
	      }
	
	      return pass;
	    },
	
	    // find values with dotted names
	    d: function(key, ctx, partials, returnFound) {
	      var found,
	          names = key.split('.'),
	          val = this.f(names[0], ctx, partials, returnFound),
	          doModelGet = this.options.modelGet,
	          cx = null;
	
	      if (key === '.' && isArray(ctx[ctx.length - 2])) {
	        val = ctx[ctx.length - 1];
	      } else {
	        for (var i = 1; i < names.length; i++) {
	          found = findInScope(names[i], val, doModelGet);
	          if (found !== undefined) {
	            cx = val;
	            val = found;
	          } else {
	            val = '';
	          }
	        }
	      }
	
	      if (returnFound && !val) {
	        return false;
	      }
	
	      if (!returnFound && typeof val == 'function') {
	        ctx.push(cx);
	        val = this.mv(val, ctx, partials);
	        ctx.pop();
	      }
	
	      return val;
	    },
	
	    // find values with normal names
	    f: function(key, ctx, partials, returnFound) {
	      var val = false,
	          v = null,
	          found = false,
	          doModelGet = this.options.modelGet;
	
	      for (var i = ctx.length - 1; i >= 0; i--) {
	        v = ctx[i];
	        val = findInScope(key, v, doModelGet);
	        if (val !== undefined) {
	          found = true;
	          break;
	        }
	      }
	
	      if (!found) {
	        return (returnFound) ? false : "";
	      }
	
	      if (!returnFound && typeof val == 'function') {
	        val = this.mv(val, ctx, partials);
	      }
	
	      return val;
	    },
	
	    // higher order templates
	    ls: function(func, cx, partials, text, tags) {
	      var oldTags = this.options.delimiters;
	
	      this.options.delimiters = tags;
	      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
	      this.options.delimiters = oldTags;
	
	      return false;
	    },
	
	    // compile text
	    ct: function(text, cx, partials) {
	      if (this.options.disableLambda) {
	        throw new Error('Lambda features disabled.');
	      }
	      return this.c.compile(text, this.options).render(cx, partials);
	    },
	
	    // template result buffering
	    b: function(s) { this.buf += s; },
	
	    fl: function() { var r = this.buf; this.buf = ''; return r; },
	
	    // method replace section
	    ms: function(func, ctx, partials, inverted, start, end, tags) {
	      var textSource,
	          cx = ctx[ctx.length - 1],
	          result = func.call(cx);
	
	      if (typeof result == 'function') {
	        if (inverted) {
	          return true;
	        } else {
	          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
	          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
	        }
	      }
	
	      return result;
	    },
	
	    // method replace variable
	    mv: function(func, ctx, partials) {
	      var cx = ctx[ctx.length - 1];
	      var result = func.call(cx);
	
	      if (typeof result == 'function') {
	        return this.ct(coerceToString(result.call(cx)), cx, partials);
	      }
	
	      return result;
	    },
	
	    sub: function(name, context, partials, indent) {
	      var f = this.subs[name];
	      if (f) {
	        this.activeSub = name;
	        f(context, partials, this, indent);
	        this.activeSub = false;
	      }
	    }
	
	  };
	
	  //Find a key in an object
	  function findInScope(key, scope, doModelGet) {
	    var val;
	
	    if (scope && typeof scope == 'object') {
	
	      if (scope[key] !== undefined) {
	        val = scope[key];
	
	      // try lookup with get for backbone or similar model data
	      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
	        val = scope.get(key);
	      }
	    }
	
	    return val;
	  }
	
	  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
	    function PartialTemplate() {};
	    PartialTemplate.prototype = instance;
	    function Substitutions() {};
	    Substitutions.prototype = instance.subs;
	    var key;
	    var partial = new PartialTemplate();
	    partial.subs = new Substitutions();
	    partial.subsText = {};  //hehe. substext.
	    partial.buf = '';
	
	    stackSubs = stackSubs || {};
	    partial.stackSubs = stackSubs;
	    partial.subsText = stackText;
	    for (key in subs) {
	      if (!stackSubs[key]) stackSubs[key] = subs[key];
	    }
	    for (key in stackSubs) {
	      partial.subs[key] = stackSubs[key];
	    }
	
	    stackPartials = stackPartials || {};
	    partial.stackPartials = stackPartials;
	    for (key in partials) {
	      if (!stackPartials[key]) stackPartials[key] = partials[key];
	    }
	    for (key in stackPartials) {
	      partial.partials[key] = stackPartials[key];
	    }
	
	    return partial;
	  }
	
	  var rAmp = /&/g,
	      rLt = /</g,
	      rGt = />/g,
	      rApos = /\'/g,
	      rQuot = /\"/g,
	      hChars = /[&<>\"\']/;
	
	  function coerceToString(val) {
	    return String((val === null || val === undefined) ? '' : val);
	  }
	
	  function hoganEscape(str) {
	    str = coerceToString(str);
	    return hChars.test(str) ?
	      str
	        .replace(rAmp, '&amp;')
	        .replace(rLt, '&lt;')
	        .replace(rGt, '&gt;')
	        .replace(rApos, '&#39;')
	        .replace(rQuot, '&quot;') :
	      str;
	  }
	
	  var isArray = Array.isArray || function(a) {
	    return Object.prototype.toString.call(a) === '[object Array]';
	  };
	
	})( true ? exports : Hogan);


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var H = __webpack_require__(11);
	module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<style>");t.b("\n" + i);t.b("  @-webkit-keyframes heartbeat {");t.b("\n" + i);t.b("    12% {");t.b("\n" + i);t.b("      -webkit-transform: scale(1.3);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    24% {");t.b("\n" + i);t.b("      -webkit-transform: scale(1);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    36% {");t.b("\n" + i);t.b("      -webkit-transform: scale(1.3);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    48% {");t.b("\n" + i);t.b("      -webkit-transform: scale(1);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  @keyframes heartbeat {");t.b("\n" + i);t.b("    12% {");t.b("\n" + i);t.b("      transform: scale(1.3);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    24% {");t.b("\n" + i);t.b("      transform: scale(1);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    36% {");t.b("\n" + i);t.b("      transform: scale(1.3);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    48% {");t.b("\n" + i);t.b("      transform: scale(1);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-widget-content {");t.b("\n" + i);t.b("    display: block;");t.b("\n" + i);t.b("    font-family: Gibson, sans-serif;");t.b("\n" + i);t.b("    min-width: 280px;");t.b("\n" + i);t.b("    text-align: center;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-widget-content svg {");t.b("\n" + i);t.b("    vertical-align: middle;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-button {");t.b("\n" + i);t.b("    background: #de6628;");t.b("\n" + i);t.b("    border: 0;");t.b("\n" + i);t.b("    border-radius: 3px;");t.b("\n" + i);t.b("    box-sizing: border-box;");t.b("\n" + i);t.b("    color: #FFF;");t.b("\n" + i);t.b("    cursor: pointer;");t.b("\n" + i);t.b("    display: inline-block;");t.b("\n" + i);t.b("    font-family: Gibson, sans-serif;");t.b("\n" + i);t.b("    font-size: 13px;");t.b("\n" + i);t.b("    -webkit-font-smoothing: antialiased;");t.b("\n" + i);t.b("    -moz-osx-font-smoothing: grayscale;");t.b("\n" + i);t.b("    font-weight: bold;");t.b("\n" + i);t.b("    padding: 14px 2em 13px;");t.b("\n" + i);t.b("    text-align: center;");t.b("\n" + i);t.b("    text-transform: uppercase;");t.b("\n" + i);t.b("    -webkit-transition: background 0.2s;");t.b("\n" + i);t.b("    transition: background 0.2s;");t.b("\n" + i);t.b("    -webkit-user-select: none;");t.b("\n" + i);t.b("    -moz-user-select: none;");t.b("\n" + i);t.b("    -ms-user-select: none;");t.b("\n" + i);t.b("    user-select: none;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-button:hover {");t.b("\n" + i);t.b("    background: #b7511c;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-stats {");t.b("\n" + i);t.b("    border: 1px solid #ccc;");t.b("\n" + i);t.b("    border-radius: 5px;");t.b("\n" + i);t.b("    box-sizing: border-box;");t.b("\n" + i);t.b("    cursor: default;");t.b("\n" + i);t.b("    display: inline-block;");t.b("\n" + i);t.b("    font-size: 13px;");t.b("\n" + i);t.b("    margin-left: 5px;");t.b("\n" + i);t.b("    padding: 13px 12px 11px;");t.b("\n" + i);t.b("    position: relative;");t.b("\n" + i);t.b("    text-align: center;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-stats:before,");t.b("\n" + i);t.b("  .tpm-stats:after {");t.b("\n" + i);t.b("    border-left: 0;");t.b("\n" + i);t.b("    bottom: 0;");t.b("\n" + i);t.b("    content: '';");t.b("\n" + i);t.b("    height: 0;");t.b("\n" + i);t.b("    margin: auto;");t.b("\n" + i);t.b("    position: absolute;");t.b("\n" + i);t.b("    right: 100%;");t.b("\n" + i);t.b("    top: 0;");t.b("\n" + i);t.b("    width: 0;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-stats:before {");t.b("\n" + i);t.b("    border: 5px solid transparent;");t.b("\n" + i);t.b("    border-right-color: #aaa;");t.b("\n" + i);t.b("    border-right-width: 7px;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-stats:after {");t.b("\n" + i);t.b("    border: 4px solid transparent;");t.b("\n" + i);t.b("    border-right-color: #fff;");t.b("\n" + i);t.b("    border-right-width: 6px;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-stats span {");t.b("\n" + i);t.b("    vertical-align: middle;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-widget .tpm-stats svg {");t.b("\n" + i);t.b("    -webkit-transform-origin: 50%;");t.b("\n" + i);t.b("    transform-origin: 50%;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-stats path {");t.b("\n" + i);t.b("    fill: #fff;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-widget[data-animate='begin'] .tpm-stats.-upvoted path {");t.b("\n" + i);t.b("    -webkit-transition: fill 0.3s 0.4s;");t.b("\n" + i);t.b("    transition: fill 0.3s 0.4s;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-widget[data-animate='begin'] .tpm-stats.-upvoted path,");t.b("\n" + i);t.b("  .tpm-widget[data-animate='end'] .tpm-stats.-upvoted path {");t.b("\n" + i);t.b("    fill: #E75B25;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-widget[data-animate='begin'] .tpm-stats.-upvoted svg {");t.b("\n" + i);t.b("    -webkit-animation: heartbeat 0.8s;");t.b("\n" + i);t.b("    animation: heartbeat 0.8s;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-upload-cta {");t.b("\n" + i);t.b("    border: 0;");t.b("\n" + i);t.b("    background: #fff;");t.b("\n" + i);t.b("    box-sizing: border-box;");t.b("\n" + i);t.b("    color: #aaa;");t.b("\n" + i);t.b("    cursor: pointer;");t.b("\n" + i);t.b("    display: block;");t.b("\n" + i);t.b("    font-family: Gibson, sans-serif;");t.b("\n" + i);t.b("    font-size: 14px;");t.b("\n" + i);t.b("    margin: 0 auto;");t.b("\n" + i);t.b("    padding: 12px 1em 10px;");t.b("\n" + i);t.b("    text-align: center;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-upload-cta span {");t.b("\n" + i);t.b("    margin-left: 5px;");t.b("\n" + i);t.b("    vertical-align: middle;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("  .tpm-sr-only {");t.b("\n" + i);t.b("    border: 0;");t.b("\n" + i);t.b("    clip: rect(0, 0, 0, 0);");t.b("\n" + i);t.b("    height: 1px;");t.b("\n" + i);t.b("    margin: -1px;");t.b("\n" + i);t.b("    overflow: hidden;");t.b("\n" + i);t.b("    padding: 0;");t.b("\n" + i);t.b("    position: absolute;");t.b("\n" + i);t.b("    width: 1px;");t.b("\n" + i);t.b("  }");t.b("\n" + i);t.b("</style>");t.b("\n");t.b("\n" + i);if(t.s(t.f("modalOpen",c,p,1),c,p,0,3176,5840,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <style>");t.b("\n" + i);t.b("    html,");t.b("\n" + i);t.b("    body {");t.b("\n" + i);t.b("      height: 100%;");t.b("\n" + i);t.b("      overflow: hidden;");t.b("\n" + i);t.b("      width: 100%;");t.b("\n" + i);t.b("    }");t.b("\n");t.b("\n" + i);t.b("    /* resolves bug in iOS where modal displayed halfway off-screen */");t.b("\n" + i);t.b("    .footer {");t.b("\n" + i);t.b("      display: none;");t.b("\n" + i);t.b("    }");t.b("\n");t.b("\n" + i);t.b("    .tpm-modal-background {");t.b("\n" + i);t.b("      background: #3dbbc2;");t.b("\n" + i);t.b("      box-sizing: border-box;");t.b("\n" + i);t.b("      background: rgba(61,187,194,0.95);");t.b("\n" + i);t.b("      left: 0;");t.b("\n" + i);t.b("      position: absolute;");t.b("\n" + i);t.b("      top: 0;");t.b("\n" + i);t.b("      right: 0;");t.b("\n" + i);t.b("      bottom: 0;");t.b("\n" + i);t.b("      height: 100%;");t.b("\n" + i);t.b("      width: 100%;");t.b("\n" + i);t.b("      z-index: 10000;");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    .tpm-modal-close {");t.b("\n" + i);t.b("      background: transparent;");t.b("\n" + i);t.b("      border: 0 solid transparent;");t.b("\n" + i);t.b("      border-bottom-width: 80px;");t.b("\n" + i);t.b("      border-right-color: #e65924;");t.b("\n" + i);t.b("      border-right-width: 80px;");t.b("\n" + i);t.b("      color: #fff;");t.b("\n" + i);t.b("      cursor: pointer;");t.b("\n" + i);t.b("      display: block;");t.b("\n" + i);t.b("      height: 0;");t.b("\n" + i);t.b("      overflow: visible; /* for IE */");t.b("\n" + i);t.b("      padding: 0;");t.b("\n" + i);t.b("      position: absolute;");t.b("\n" + i);t.b("      right: 0;");t.b("\n" + i);t.b("      top: 0;");t.b("\n" + i);t.b("      width: 0;");t.b("\n" + i);t.b("      z-index: 2;");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    @media (min-width: 500px) {");t.b("\n" + i);t.b("      .tpm-modal-close {");t.b("\n" + i);t.b("        border-bottom-width: 100px;");t.b("\n" + i);t.b("        border-right-width: 100px;");t.b("\n" + i);t.b("      }");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    .tpm-modal-close:after {");t.b("\n" + i);t.b("      background: #e65924;");t.b("\n" + i);t.b("      content: '\\00d7';");t.b("\n" + i);t.b("      color: #fff;");t.b("\n" + i);t.b("      font-size: 32px;");t.b("\n" + i);t.b("      -webkit-font-smoothing: antialiased;");t.b("\n" + i);t.b("      -moz-osx-font-smoothing: grayscale;");t.b("\n" + i);t.b("      font-smoothing: antialiased;");t.b("\n" + i);t.b("      height: 40px;");t.b("\n" + i);t.b("      line-height: 40px;");t.b("\n" + i);t.b("      position: absolute;");t.b("\n" + i);t.b("      right: -80px;");t.b("\n" + i);t.b("      width: 40px;");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    @media (min-width: 500px) {");t.b("\n" + i);t.b("      .tpm-modal-close:after {");t.b("\n" + i);t.b("        font-size: 48px;");t.b("\n" + i);t.b("        height: 50px;");t.b("\n" + i);t.b("        line-height: 50px;");t.b("\n" + i);t.b("        right: -100px;");t.b("\n" + i);t.b("        width: 50px;");t.b("\n" + i);t.b("      }");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    .tpm-modal-content {");t.b("\n" + i);t.b("      background: #fff;");t.b("\n" + i);t.b("      box-shadow: 0 7px 0 rgba(0,0,0,0.2);");t.b("\n" + i);t.b("      box-sizing: border-box;");t.b("\n" + i);t.b("      display: block;");t.b("\n" + i);t.b("      height: 100%;");t.b("\n" + i);t.b("      margin: auto;");t.b("\n" + i);t.b("      max-width: 480px;");t.b("\n" + i);t.b("      position: relative;");t.b("\n" + i);t.b("      z-index: 1;");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    @media (min-width: 450px) {");t.b("\n" + i);t.b("      .tpm-modal-content {");t.b("\n" + i);t.b("        overflow: hidden;");t.b("\n" + i);t.b("        border-radius: 5px;");t.b("\n" + i);t.b("        height: 660px;");t.b("\n" + i);t.b("        max-height: 100vh;");t.b("\n" + i);t.b("        top: 50%;");t.b("\n" + i);t.b("        -webkit-transform: translateY(-50%);");t.b("\n" + i);t.b("        -ms-transform: translateY(-50%);");t.b("\n" + i);t.b("        transform: translateY(-50%);");t.b("\n" + i);t.b("      }");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("    .tpm-modal-iframe {");t.b("\n" + i);t.b("      border: none;");t.b("\n" + i);t.b("      height: 100%;");t.b("\n" + i);t.b("      width: 100%;");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("  </style>");t.b("\n" + i);t.b("  <div id=\"tpm-modal-background\" class=\"tpm-modal-background\">");t.b("\n" + i);t.b("    <div class=\"tpm-modal-content\">");t.b("\n" + i);t.b("      <button id=\"tpm-modal-close\" type=\"button\" class=\"tpm-modal-close\">");t.b("\n" + i);t.b("        <span class=\"tpm-sr-only\">Close</span>");t.b("\n" + i);t.b("      </button>");t.b("\n" + i);t.b("      <iframe id=\"tpm-modal-iframe\" class=\"tpm-modal-iframe\" src=\"");t.b(t.v(t.f("tpmHost",c,p,0)));t.b("/widgets/");t.b(t.v(t.f("widgetId",c,p,0)));t.b("/submissions/new\" />");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("<div class=\"tpm-widget-content\">");t.b("\n" + i);t.b("  <button id=\"tpm-button\" type=\"button\" class=\"tpm-button\">This Place Matters</button>");t.b("\n" + i);if(t.s(t.f("upvotedByAnybody",c,p,1),c,p,0,5999,6644,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"tpm-stats ");t.b(t.v(t.f("upvoteStatClass",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"15\" viewBox=\"0 0 18 15\"><path fill=\"#FFFFFF\" stroke=\"#E75B25\" stroke-width=\"2\" d=\"M2.245 7.767C1.444 6.968 1 5.989 1 4.834S1.444 2.7 2.245 1.989c0.8-0.711 1.867-1.155 3.022-1.155C6.333 0.834 7.4 1.19 8.2 1.989l0 0 0.089 0.089L9 2.7l0.8-0.711c0.799-0.799 1.867-1.155 2.933-1.155 1.155 0 2.223 0.444 3.021 1.155C16.556 2.79 17 3.767 17 4.834s-0.444 2.134-1.245 2.845L9 14.167 2.245 7.767z\"/></svg>");t.b("\n" + i);t.b("      <span>");t.b(t.v(t.f("upvoteStatNumber",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      <span class=\"tpm-sr-only\">");t.b(t.v(t.f("upvoteStatWord",c,p,0)));t.b(" said this place matters</span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("  <button id=\"tpm-upload-cta\" type=\"button\" class=\"tpm-upload-cta\">");t.b("\n" + i);t.b("    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"17\" viewBox=\"0 0 22 17\"><path fill=\"#E75B25\" d=\"M19 1V0h-4v1H3C1.3 1 0 2.3 0 4v10c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V4C22 2.3 20.7 1 19 1zM11 14c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S13.8 14 11 14zM11 6C9.3 6 8 7.3 8 9s1.3 3 3 3 3-1.3 3-3S12.7 6 11 6z\"/></svg>");t.b("\n" + i);t.b("    <span>Share your story or photo</span>");t.b("\n" + i);t.b("  </button>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<style>\n  @-webkit-keyframes heartbeat {\n    12% {\n      -webkit-transform: scale(1.3);\n    }\n    24% {\n      -webkit-transform: scale(1);\n    }\n    36% {\n      -webkit-transform: scale(1.3);\n    }\n    48% {\n      -webkit-transform: scale(1);\n    }\n  }\n  @keyframes heartbeat {\n    12% {\n      transform: scale(1.3);\n    }\n    24% {\n      transform: scale(1);\n    }\n    36% {\n      transform: scale(1.3);\n    }\n    48% {\n      transform: scale(1);\n    }\n  }\n  .tpm-widget-content {\n    display: block;\n    font-family: Gibson, sans-serif;\n    min-width: 280px;\n    text-align: center;\n  }\n  .tpm-widget-content svg {\n    vertical-align: middle;\n  }\n  .tpm-button {\n    background: #de6628;\n    border: 0;\n    border-radius: 3px;\n    box-sizing: border-box;\n    color: #FFF;\n    cursor: pointer;\n    display: inline-block;\n    font-family: Gibson, sans-serif;\n    font-size: 13px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-weight: bold;\n    padding: 14px 2em 13px;\n    text-align: center;\n    text-transform: uppercase;\n    -webkit-transition: background 0.2s;\n    transition: background 0.2s;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n  .tpm-button:hover {\n    background: #b7511c;\n  }\n  .tpm-stats {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-sizing: border-box;\n    cursor: default;\n    display: inline-block;\n    font-size: 13px;\n    margin-left: 5px;\n    padding: 13px 12px 11px;\n    position: relative;\n    text-align: center;\n  }\n  .tpm-stats:before,\n  .tpm-stats:after {\n    border-left: 0;\n    bottom: 0;\n    content: '';\n    height: 0;\n    margin: auto;\n    position: absolute;\n    right: 100%;\n    top: 0;\n    width: 0;\n  }\n  .tpm-stats:before {\n    border: 5px solid transparent;\n    border-right-color: #aaa;\n    border-right-width: 7px;\n  }\n  .tpm-stats:after {\n    border: 4px solid transparent;\n    border-right-color: #fff;\n    border-right-width: 6px;\n  }\n  .tpm-stats span {\n    vertical-align: middle;\n  }\n  .tpm-widget .tpm-stats svg {\n    -webkit-transform-origin: 50%;\n    transform-origin: 50%;\n  }\n  .tpm-stats path {\n    fill: #fff;\n  }\n  .tpm-widget[data-animate='begin'] .tpm-stats.-upvoted path {\n    -webkit-transition: fill 0.3s 0.4s;\n    transition: fill 0.3s 0.4s;\n  }\n  .tpm-widget[data-animate='begin'] .tpm-stats.-upvoted path,\n  .tpm-widget[data-animate='end'] .tpm-stats.-upvoted path {\n    fill: #E75B25;\n  }\n  .tpm-widget[data-animate='begin'] .tpm-stats.-upvoted svg {\n    -webkit-animation: heartbeat 0.8s;\n    animation: heartbeat 0.8s;\n  }\n  .tpm-upload-cta {\n    border: 0;\n    background: #fff;\n    box-sizing: border-box;\n    color: #aaa;\n    cursor: pointer;\n    display: block;\n    font-family: Gibson, sans-serif;\n    font-size: 14px;\n    margin: 0 auto;\n    padding: 12px 1em 10px;\n    text-align: center;\n  }\n  .tpm-upload-cta span {\n    margin-left: 5px;\n    vertical-align: middle;\n  }\n  .tpm-sr-only {\n    border: 0;\n    clip: rect(0, 0, 0, 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n</style>\n\n{{#modalOpen}}\n  <style>\n    html,\n    body {\n      height: 100%;\n      overflow: hidden;\n      width: 100%;\n    }\n\n    /* resolves bug in iOS where modal displayed halfway off-screen */\n    .footer {\n      display: none;\n    }\n\n    .tpm-modal-background {\n      background: #3dbbc2;\n      box-sizing: border-box;\n      background: rgba(61,187,194,0.95);\n      left: 0;\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      height: 100%;\n      width: 100%;\n      z-index: 10000;\n    }\n    .tpm-modal-close {\n      background: transparent;\n      border: 0 solid transparent;\n      border-bottom-width: 80px;\n      border-right-color: #e65924;\n      border-right-width: 80px;\n      color: #fff;\n      cursor: pointer;\n      display: block;\n      height: 0;\n      overflow: visible; /* for IE */\n      padding: 0;\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 0;\n      z-index: 2;\n    }\n    @media (min-width: 500px) {\n      .tpm-modal-close {\n        border-bottom-width: 100px;\n        border-right-width: 100px;\n      }\n    }\n    .tpm-modal-close:after {\n      background: #e65924;\n      content: '\\00d7';\n      color: #fff;\n      font-size: 32px;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      font-smoothing: antialiased;\n      height: 40px;\n      line-height: 40px;\n      position: absolute;\n      right: -80px;\n      width: 40px;\n    }\n    @media (min-width: 500px) {\n      .tpm-modal-close:after {\n        font-size: 48px;\n        height: 50px;\n        line-height: 50px;\n        right: -100px;\n        width: 50px;\n      }\n    }\n    .tpm-modal-content {\n      background: #fff;\n      box-shadow: 0 7px 0 rgba(0,0,0,0.2);\n      box-sizing: border-box;\n      display: block;\n      height: 100%;\n      margin: auto;\n      max-width: 480px;\n      position: relative;\n      z-index: 1;\n    }\n    @media (min-width: 450px) {\n      .tpm-modal-content {\n        overflow: hidden;\n        border-radius: 5px;\n        height: 660px;\n        max-height: 100vh;\n        top: 50%;\n        -webkit-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        transform: translateY(-50%);\n      }\n    }\n    .tpm-modal-iframe {\n      border: none;\n      height: 100%;\n      width: 100%;\n    }\n  </style>\n  <div id=\"tpm-modal-background\" class=\"tpm-modal-background\">\n    <div class=\"tpm-modal-content\">\n      <button id=\"tpm-modal-close\" type=\"button\" class=\"tpm-modal-close\">\n        <span class=\"tpm-sr-only\">Close</span>\n      </button>\n      <iframe id=\"tpm-modal-iframe\" class=\"tpm-modal-iframe\" src=\"{{tpmHost}}/widgets/{{widgetId}}/submissions/new\" />\n    </div>\n  </div>\n{{/modalOpen}}\n\n<div class=\"tpm-widget-content\">\n  <button id=\"tpm-button\" type=\"button\" class=\"tpm-button\">This Place Matters</button>\n  {{#upvotedByAnybody}}\n    <div class=\"tpm-stats {{upvoteStatClass}}\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"15\" viewBox=\"0 0 18 15\"><path fill=\"#FFFFFF\" stroke=\"#E75B25\" stroke-width=\"2\" d=\"M2.245 7.767C1.444 6.968 1 5.989 1 4.834S1.444 2.7 2.245 1.989c0.8-0.711 1.867-1.155 3.022-1.155C6.333 0.834 7.4 1.19 8.2 1.989l0 0 0.089 0.089L9 2.7l0.8-0.711c0.799-0.799 1.867-1.155 2.933-1.155 1.155 0 2.223 0.444 3.021 1.155C16.556 2.79 17 3.767 17 4.834s-0.444 2.134-1.245 2.845L9 14.167 2.245 7.767z\"/></svg>\n      <span>{{upvoteStatNumber}}</span>\n      <span class=\"tpm-sr-only\">{{upvoteStatWord}} said this place matters</span>\n    </div>\n  {{/upvotedByAnybody}}\n  <button id=\"tpm-upload-cta\" type=\"button\" class=\"tpm-upload-cta\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"17\" viewBox=\"0 0 22 17\"><path fill=\"#E75B25\" d=\"M19 1V0h-4v1H3C1.3 1 0 2.3 0 4v10c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V4C22 2.3 20.7 1 19 1zM11 14c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S13.8 14 11 14zM11 6C9.3 6 8 7.3 8 9s1.3 3 3 3 3-1.3 3-3S12.7 6 11 6z\"/></svg>\n    <span>Share your story or photo</span>\n  </button>\n</div>\n", H);return T; }();

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** thisplacematters-widget.js
 **/